import useRenderChapas from '../../hooks/useRenderChapas';

const PosterFormatType = ({ item }) => {
  const { renderLabel } = useRenderChapas();

  return renderLabel(item);
};

export default PosterFormatType;
